import { EventEmitter, Injectable } from '@angular/core';
import { Mimic } from 'icreate/common/models/mimic';
import { BehaviorSubject, Subject } from 'rxjs';

export enum MenuTabs {
    DESIGN = 'mimic.page.side-menu.title.design',
    SETTINGS = 'mimic.page.side-menu.title.settings',
}

@Injectable({ providedIn: 'root' })
export class EditorService {
    private currentMimicSubject = new BehaviorSubject<Mimic>(null);
    public currentMimic$ = this.currentMimicSubject.asObservable();

    private currentMimicIsDeletedSubject = new BehaviorSubject<boolean>(false);
    public currentMimicIsDeleted$ = this.currentMimicIsDeletedSubject.asObservable();

    private mimicContentSubject = new Subject<string>();
    public updateMimicContent$ = this.mimicContentSubject.asObservable();

    private currentSelectedTabSubject = new BehaviorSubject<MenuTabs>(null);
    public currentSelectedTab$ = this.currentSelectedTabSubject.asObservable();

    editorLoadingEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();

    setCurrentMimicIsDeleted(deleted: boolean) {
        this.currentMimicIsDeletedSubject.next(deleted);
    }

    getCurrentMimicIsDeleted() {
        return this.currentMimicIsDeletedSubject.value;
    }

    setCurrentMimic(mimic: Mimic) {
        this.currentMimicSubject.next(mimic);
    }

    updateMimicContent(mimicContent) {
        this.mimicContentSubject.next(mimicContent);
    }

    getCurrentMimic(): Mimic {
        return this.currentMimicSubject.value;
    }

    setCurrentSelectedTab(tab: MenuTabs) {
        this.currentSelectedTabSubject.next(tab);
    }

    showLoadingSpinner(showSpinner) {
        this.editorLoadingEmitter.emit(showSpinner);
    }
}
